export const PLACE_ORDER = "PLACE_ORDER";
export const PLACE_SPOT_ORDER = "PLACE_SPOT_ORDER";
